module.exports = __webpack_public_path__ + "img/personal_resources_list_wrong.8f7a16be.svg";